export enum FactoryComponents {
  none = 0,
    Dispatches = 1,
    Quotes = 2,
    Orders = 3,
    Invoices = 4,
    DQOI = 5
}
